import emailjs from 'emailjs-com';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import pdf_es from '../data/terminos&condiciones2023.pdf';
import pdf_eu from '../data/terms&conditions2023.pdf';

const initialState = {
  name: '',
  email: '',
  message: '',
};
export const DeleteData = (props) => {
  const { t, i18n } = useTranslation('global');
  const currentLang = i18n.language;
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID')
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2> {t('contact.deleteTitle')}</h2>
                <p className='text-white'>{t('contact.deleteDescription')}</p>
              </div>
              <form name='sentMessage' onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder={t('contact.name')}
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='lastName'
                        name='lastName'
                        className='form-control'
                        placeholder={t('contact.lastName')}
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder={t('contact.email')}
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  {t('contact.send')}
                </button>
              </form>
              <div className='section-title'>
                <h2> {t('contact.deleteDataPolicyTitle')}</h2>
                <p className='text-white'>
                  {t('contact.deleteDataPolicyDescription')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>{t('contact.info')}</h3>
              {/* <p>
                <span>
                  <i className='fa fa-map-marker'></i> Dirección
                </span>
                {props.data ? props.data.address : 'loading'}
              </p> */}
            </div>
            <div className='contact-item'>
              <p className='text-white'>
                <span>
                  <i className='fa fa-phone'></i> {t('contact.tel')}
                </span>{' '}
                {props.data ? props.data.phone : t('contact.phone')}
              </p>
            </div>
            <div className='contact-item'>
              <p className='text-white'>
                <span>
                  <i className='fa fa-envelope-o'></i> {t('contact.email')}
                </span>{' '}
                {props.data ? props.data.email : t('contact.emailAddress')}
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a
                      href={props.data ? props.data.facebook : t('contact.facebook')}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.youtube : t('contact.youtube')}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2022 SIAT.{' '}
            <a
              href={currentLang === 'es' ? pdf_es : pdf_eu}
              target='_blank'
              rel='noreferrer'
            >
              {t('terms')}
            </a>
            {' - '}
            <Link to='/privacy'>{t('privacy')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
};
